<template>
  <!-- pagination : ‹ 1 … 4 5 6 … 12 › (pages côté serveur) -->
  <ul class="pagination pagination-sm mb-0">
    <li class="page-item previous" :class="{ disabled: page <= 1 || disabled }">
      <a href="#" class="page-link" @click.prevent="go(page - 1)"><i class="previous"></i></a>
    </li>
    <li v-for="(item, index) in items" :key="index" class="page-item" :class="{ active: item === page, disabled: item === '…' || disabled }">
      <span v-if="item === '…'" class="page-link">…</span>
      <a v-else href="#" class="page-link" @click.prevent="go(item)">{{ item }}</a>
    </li>
    <li class="page-item next" :class="{ disabled: page >= last || disabled }">
      <a href="#" class="page-link" @click.prevent="go(page + 1)"><i class="next"></i></a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PageNumbers',
  props: {
    page: { type: Number, required: true },
    last: { type: Number, required: true },
    disabled: { type: Boolean, default: false },
  },
  emits: ['change'],

  computed: {
    // première, dernière, et deux pages de chaque côté de la page en cours
    items() {
      const pages = []
      for (let number = 1; number <= this.last; number++) {
        if (number === 1 || number === this.last || Math.abs(number - this.page) <= 2) {
          pages.push(number)
        } else if (pages[pages.length - 1] !== '…') {
          pages.push('…')
        }
      }
      return pages
    },
  },

  methods: {
    go(number) {
      if (this.disabled || number < 1 || number > this.last || number === this.page) return
      this.$emit('change', number)
    },
  },
}
</script>
